import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { ToolbarControl, ToolbarButton } from '../../controls/ToolbarControl';
import { ToggleSwitchControl } from '../../controls/ToggleSwitchControl';
import { PageableDataObjectList } from '../../dataControls/PageableDataObjectList';
import { DataManager } from '../../dataControls/DataManager';
import { TextboxDataControl } from '../../dataControls/TextboxDataControl';
import { Card } from '../../components/Containers';
import { Logger } from "../../infrastructure/Logger";
import { InterfaceMode, ToolbarComponent } from '../../dataForms/GenericComponent';
import { DropdownDataSourceDataControl } from '../../dataControls/DropdownDataSourceDataControl';

export class StandardProductCategoryView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dataId: null,
            mode: InterfaceMode.List
        }

        this.list = null;
    }

    onListClick() {
        this.setState({
            dataId: null,
            mode: InterfaceMode.List
        });
    }

    onNewClick() {
        this.setState({
            dataId: null,
            mode: InterfaceMode.New
        });
    }

    onEditClick(id) {
        this.setState({
            dataId: id,
            mode: InterfaceMode.Edit
        });
    }

    renderComponent(mode) {
        switch (mode) {
            case InterfaceMode.List:
                return <StandardProductCategoryListView onNewClick={() => { this.onNewClick() }} onEditClick={id => { this.onEditClick(id) }} />
                break;
            case InterfaceMode.New:
                return <StandardProductCategoryEditorView dataId={this.state.dataId} onListClick={() => { this.onListClick() }} />
                break;
            case InterfaceMode.Edit:
                return <StandardProductCategoryEditorView dataId={this.state.dataId} onListClick={() => { this.onListClick() }} />
                break;
            default:
                return <StandardProductCategoryListView onNewClick={() => { this.onNewClick() }} onEditClick={id => { this.onEditClick(id) }} />
                break;
        }
    }

    render() {
        return (
            <div className="view">
                <ImageTitle text='Categories' />
                {this.renderComponent(this.state.mode)}
            </div>
        )
    }
}


export class StandardProductCategoryEditorView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isValid: false
        };

        this.onControlBound = this.onControlBound.bind(this);
        this.onControlUnbound = this.onControlUnbound.bind(this);
        this.onValidated = this.onValidated.bind(this);

        this.dataManager = new DataManager(
            'standard-product-category',
            this.onControlBound,
            this.onControlUnbound,
            this.onValidated);
    }

    componentDidMount() {
        this.dataManager.init()
            .then(dataManager => {
                //1) load Data
                if (this.props.dataId) {

                    dataManager.loadContext(this.props.dataId)
                        .then(() => {
                            //2) bind Controls                           
                            dataManager.bindControls();
                        })
                        .catch(ex => {
                            Logger.writeError("Could not load Standard Product Department", ex);
                            window.Router.setNotFound();
                        });
                }
                else {
                    //2) bind Controls
                    dataManager.bindControls();
                }
            });
    }

    onControlBound(control, propertyName) {
        var value = this.dataManager.dataObject[propertyName];
        if (value) {
            control.setValue(value);
        }
    }

    onControlUnbound(control, propertyName) {
    }


    onValidated(isValid) {

        this.setState({
            isValid: isValid
        });
    }

    onListClick() {
        if (this.props.onListClick) {
            this.props.onListClick();
        }
    }

    onNewClick() {
        if (this.props.onNewClick) {
            this.props.onNewClick();
        }
    }

    onSaveClick() {
        var self = this;

        self.dataManager.saveContext()
            .then(data => {
                window.Alerts.showSuccess('Category - ' + data.id + ' has been saved');
                self.onListClick()
            })
            .catch(error => {
                window.Alerts.showError('An error occurred while saving the Category');
            });
    }

    render() {
        return (
            <div>

                <ToolbarComponent mode={InterfaceMode.New}
                    onListClick={() => { this.onListClick() }}
                    onNewClick={() => { this.onNewClick() }}
                />

                <Card title='Category' subtitle='Define the Category below'>

                    <label htmlFor='name'>Department</label>
                    <DropdownDataSourceDataControl dataManager={this.dataManager} propertyName='departmentId' />


                    <label htmlFor='name'>Category Name</label>
                    <TextboxDataControl dataManager={this.dataManager} propertyName='name' />

                </Card>

                <button className='btn btn-lg btn-primary' onClick={() => { this.onListClick() }}>Cancel</button>
                <button className='btn btn-secondary pull-right' disabled={!this.state.isValid} onClick={() => { this.onSaveClick() }}>Save</button>
            </div>
        );
    }
}



export class StandardProductCategoryListView extends React.Component {

    constructor(props) {
        super(props);

        this.list = null;

        this.dataManager = new DataManager('standard-product-category');
    }

    onNewClick() {
        if (this.props.onNewClick) {
            this.props.onNewClick();
        }
    }

    onEditClick(item) {
        if (this.props.onEditClick) {
            this.props.onEditClick(item.id);
        }
    }

    async onPublishToggle(item, value, toggle) {
        console.log(item, value, toggle)
        await this.dataManager.loadContext(item.id);
        this.dataManager.dataObject['isPublished'] = value;
        await this.dataManager.saveContext();
        this.list.refresh(null, true);
    }

    async onDeleteClick(item) {
        var self = this;

        window.Confirmation.show('Delete', 'The item will be deleted. Do you want to continue?', async () => {

            try {
                await self.dataManager.loadContext(item.id);
                await self.dataManager.delete();
                self.list.refresh(null, true);
                window.Alerts.showSuccess('The Category has been deleted');
            }
            catch {
                window.Alerts.showError('An error occurred while deleting the Category. Products might be assigned to this Category.');
            }

        });



    }


    render() {
        var self = this;
        return (
            <div>
                <ToolbarControl renderButtons={() => {
                    return (
                        <div>
                            <ToolbarButton icon='glyphicon-plus' text='New' onClick={() => { self.onNewClick() }} />
                        </div>
                    )
                }} />

                <PageableDataObjectList dataObject='standard-product-category' onInit={list => { this.list = list }}
                    onRenderTitleRow={() => {
                        return (
                            <div className='row'>
                                <div className='col col-1'>Id</div>
                                <div className='col col-1'>Delete</div>                                
                                <div className='col col-4'>Name</div>
                                <div className='col col-4'>Department</div>
                                <div className='col col-2'><div className='pull-right'>Published</div></div>
                            </div>
                        )
                    }}
                    onRenderRow={(item, idx) => {
                        return (
                            <div key={`row_${item.id}`} className='row'>
                                <div className='col col-1 clickable' onClick={() => { self.onEditClick(item) }}>{item.id}</div>
                                <div className='col col-1'><button className='btn btn-primary' onClick={() => { self.onDeleteClick(item) }}><span className='glyphicon glyphicon-trash'></span></button></div>
                                <div className='col col-4 clickable' onClick={() => { self.onEditClick(item) }}>{item.name}</div>
                                <div className='col col-4 clickable' onClick={() => { self.onEditClick(item) }}>{item.departmentId}</div>
                                <div className='col col-2'>
                                    <ToggleSwitchControl id={`toggle_spec_${item.id}`} className='pull-right' item={item} on={item.isPublished == 'True'} onChange={(value, cntrl) => self.onPublishToggle(item, value, cntrl)} />
                                </div>
                            </div>
                        )
                    }} />

            </div>
        );
    }

}


